module.exports = __webpack_public_path__ + "img/savory_active.717ab6d7.png";